export enum Country {
  GT = 1,
  SV = 2,
}

export const countries = {
  [Country.GT]: { id: Country.GT, name: 'Guatemala', ext: 'GT', iva: 0.12 },
  [Country.SV]: { id: Country.SV, name: 'El Salvador', ext: 'SV', iva: 0.13 },
}

export default countries
